import React, { createContext } from 'react';

const CurrentLocaleContext = createContext();

export default CurrentLocaleContext;
